import { PRINTING_TYPES } from "/cdn/shop/t/98/assets/printingOptions.constant.js?cash48";
import tab from "/cdn/shop/t/98/assets/tab.js?cash48";

export default {
    props: [
        "activeStepNumber",
        "isCompletedContactInformation",
        "isCompletedPrintingOptions",
        "isShowReviewSection",
    ],
    emits: [
        "select"
    ],
    data() {
        return {
            printingTypes: PRINTING_TYPES,
            selectedTab: null,
        };
    },
    components: {
        tab,
    },
    methods: {
        selectTab(tab) {
            if (this.selectedTab === tab) {
                this.selectedTab = null;
                return;
            }

            this.selectedTab = tab;
        },
    },
    template: `
            <div class="tab-list-container tabs">
                <tab @selectTab="$emit('select', { type: 'contact_information', stepNumber: 0 })" name="Contact Information" :isCompleted="isCompletedContactInformation" :isActive="activeStepNumber === 0" /> 
                <tab @selectTab="$emit('select', { type: 'printing_types', stepNumber: 1 })" name="Printing Types" :isCompleted="isCompletedPrintingOptions" :isActive="activeStepNumber && !isShowReviewSection" />
                <tab @selectTab="$emit('select', { type: 'review' })" name="Review" :is-last="true" :isActive="isShowReviewSection"></tab>
            </div>
    `,
};
